<div class="row">
  <div class="col-6">
    <h3 class="heading">
      {{ !!user.fullName ? user.fullName : user.username }} - <em>{{ user.status | replace: '_':' ' | titlecase }}</em>
    </h3>
  </div>
  <div class="col-6 text-right"><ng-content /></div>
</div>
